import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { BaseButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import { FetchCatalogOverview } from '../../../api/queries/catalog.gql';
import BaseCatalogItemCard from '../../cards/CatalogItemCard';
import Link from '../../Link';
import Paginator from '../../Paginator';

const CatalogItemCard = React.forwardRef((props, forwardedRef) => {
  const { url } = props;

  return (
    <GridItem
      ref={forwardedRef}
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      key={url}
    >
      <Link href={url}>
        <BaseCatalogItemCard {...props} />
      </Link>
    </GridItem>
  );
});

CatalogItemCard.defaultProps = {
  url: null,
};

CatalogItemCard.propTypes = {
  url: PropTypes.string,
};

const CatalogOverview = () => {
  const brand = useBrand();
  const {
    query: { slug, index },
  } = useRouter();

  const formattedIndex = index ? index.substring(0, 1) : null;

  const loadMoreButton = (
    <BaseButton variant="underline">
      <span
        onClick={() => {
          track('catalogusoverzichtNieuw', 'click', 'toon-meer-items');
        }}
        onKeyDown={() => {
          track('catalogusoverzichtNieuw', 'click', 'toon-meer-items');
        }}
        role="button"
        tabIndex={0}
      >
        Toon meer items
      </span>
    </BaseButton>
  );

  return (
    <Paginator
      limit={16}
      ItemComponent={CatalogItemCard}
      transformItemProps={({ url, slug: itemSlug, ...props }) => ({
        ...props,
        url: url || `catalogus/${slug}/${itemSlug.substring(0, 1)}/${itemSlug}`,
      })}
      query={FetchCatalogOverview}
      variables={{
        brandSlug: brand.slug,
        slug,
        index: formattedIndex,
      }}
      itemsKey="brand.catalog.items"
      loadMoreElement={loadMoreButton}
    />
  );
};

export default CatalogOverview;
